import { component } from 'picoapp';

// Utils
import { setCSSProperty } from 'utils/css';

export default component(async (node) => {
  const updateScrollOffset = () => {
    const { top } = node.getBoundingClientRect();

    setCSSProperty(node, '--scroll-offset', `${top / 2}px`);
  };

  const intersectionCallback = (entries) => {
    if (entries[0].isIntersecting) {
      node.setAttribute('open', '');
      window.addEventListener('scroll', updateScrollOffset, { passive: true });
    } else {
      window.removeEventListener('scroll', updateScrollOffset, { passive: true });
    }
  };

  const observerOptions = {
    threshold: 0.2,
  };

  const observer = new IntersectionObserver(intersectionCallback, observerOptions);
  observer.observe(node);
  setCSSProperty(node, '--scroll-offset', `${node.getBoundingClientRect().top}px`);
});
